import * as React from 'react';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';

import { connect } from 'react-redux';

import { ICalendarAppState } from '../../redux-state';
import { IEvent } from '../../interfaces';
import { ICalendarAppText } from '../../redux-state/interfaces/text/calendar-app.text';
import GridEventView from './grid-event.view';

interface IGridEventExternalProps {
    event: IEvent;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type GridEventProps = IGridEventExternalProps & StateToProps;

export const GridEventBase: React.StatelessComponent<GridEventProps> = props => {
    return (
        <GridEventView {...props} />
    )
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(GridEventBase);